import { render, staticRenderFns } from "./app-section.vue?vue&type=template&id=7828e8a1&"
import script from "./app-section.vue?vue&type=script&lang=js&"
export * from "./app-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports